module.exports = {
          srcSet: __webpack_public_path__ + "b956bedf2b3f2f353a56098c706cdd7e-70.png"+" 70w",
          images:[ {path: __webpack_public_path__ + "b956bedf2b3f2f353a56098c706cdd7e-70.png",width: 70,height: 70}],
          src: __webpack_public_path__ + "b956bedf2b3f2f353a56098c706cdd7e-70.png",
          toString:function(){return __webpack_public_path__ + "b956bedf2b3f2f353a56098c706cdd7e-70.png"},
          
          width: 70,
          height: 70
        }